import { ReactNode } from 'react';
import styled from 'styled-components';

import { c14142E, cFFFFFF, cEA135E } from '#/colors';

interface Props {
  children: ReactNode;
}

export default function TabLabel({ children }: Props) {
  return <Container>{children}</Container>;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Badge = styled.div`
  font-family: 'Roboto Mono';
  background-color: ${c14142E};
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 11px;
`;

export const BadgeDanger = styled(Badge)`
  background: ${cEA135E};
  color: ${cFFFFFF};
`;
